<template lang="pug">
div
  loading(
    v-if="isLoading"
    is-loading
  )

  template(v-else)
    page-header(
      title="We'd love to know a bit more about you"
      :error="errorMessage"
    )

    form(@submit.prevent="save")
      .w-login-form__row
        p Heya! We're working on improving some key areas of Teamwork and to ensure we&#32;
          | offer the best version for your team, we'd love to know a few things about your&#32;
          | organization. As you are an Administrator we thought you may be the best to help us.

      .w-login-form__row
        TwSelect(
          v-model="model.industryCategory"
          label="Industry category"
          name="industry-category"
          :options="industryCategoryOptions"
        )

        TwSelect(
          v-model="model.size"
          label="Company size"
          name="company-size"
          :options="sizeOptions"
        )

      .w-login-form__row
        p We appreciate your help on this,
          br
          | Dan &amp; Peter.

      button(type="submit").w-button.w-button--blue
          span.w-button__label Save
</template>

<script>
// eslint-disable-next-line @teamwork/cfb-rules/component-paths
import axios from 'axios';

import PageHeader from '@/components/widgets/PageHeader/PageHeader.vue';
import Loading from '@/components/widgets/Loading/Loading.vue';
import TwSelect from '@/components/widgets/TwSelect.vue';

export default {
  components: {
    PageHeader,
    Loading,
    TwSelect,
  },

  props: {
    defaultInfo: {
      type: Object,
      default: () => ({ industryCategoryId: undefined, sizeId: undefined }),
    },
  },

  data() {
    return {
      isLoading: false,
      errorMessage: undefined,

      companySizes: [],
      industryCategories: [],

      model: {
        size: this.defaultInfo.sizeId,
        industryCategory: this.defaultInfo.industryCategoryId,
      },
    };
  },

  created() {
    this.init();
  },

  computed: {
    sizeOptions() {
      return this.companySizes.map(({ id, label }) => ({ value: id, label }));
    },

    industryCategoryOptions() {
      return this.industryCategories.map(({ id, name }) => ({ value: id, label: name }));
    },
  },

  methods: {
    async init() {
      this.isLoading = true;

      try {
        const sizesPromise = axios.get('/launchpad/v1/companysizes.json');
        const industryCategoriesPromise = axios.get('/launchpad/v1/industrycategories.json');

        const [
          { data: { companysizes: companySizes } },
          { data: { industrycategories: industryCategories } },
        ] = await Promise.all([
          sizesPromise,
          industryCategoriesPromise,
        ]);

        this.companySizes = companySizes;
        this.industryCategories = industryCategories;
      } catch (error) {
        this.errorMessage = 'Something went wrong. Please try again later.';
      }

      this.isLoading = false;
    },

    async save() {
      const { size, industryCategory } = this.model;

      if (!size || !industryCategory) {
        this.errorMessage = 'Please fill in all fields';

        return;
      }

      try {
        this.isLoading = true;
        this.errorMessage = undefined;

        const industryCategoryId = parseInt(industryCategory, 10);
        const companySizeId = parseInt(size, 10);

        await axios.post('/launchpad/v1/industry.json', { industryCategoryId, companySizeId });

        this.$emit('saved');
      } catch (error) {
        this.errorMessage = 'Something went wrong. Please try again later.';
      }

      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/variables/_variables.scss';

.reason {
  margin-bottom: 20px;
}

.thanks {
  margin-bottom: 12px;
}

.error {
  color: $color--error;
}
</style>



// WEBPACK FOOTER //
// CompanyInfo.vue?120bf5f2